const FAVOURITES_NAME = 'favourites';

export function getFavourites(): { id: number }[] {
	return JSON.parse(localStorage.getItem(FAVOURITES_NAME) ?? '[]');
}

export function setFavourites(favourites: { id: number }[]) {
	localStorage.setItem(FAVOURITES_NAME, JSON.stringify(favourites));
}
